const footerColumns = [
  {
    title: "内容栏目",
    links: [
      { label: "世界观解析", to: "/worldview" },
      { label: "角色图鉴", to: "/characters" },
      { label: "设定百科", to: "/settings" },
      { label: "常见问题", to: "/faq" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200/80">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-store-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                洞洞杂货铺
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-700">
              专注洞洞杂货铺漫画的世界观与设定考据。从洞洞含义、杂货铺设定到故事背景与隐藏线索，
              我们把这部作品散落的伏笔整理成清晰、有深度的内容，陪你一起读懂它。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#"
                aria-label="新浪微博"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                aria-label="哔哩哔哩"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                <i className="ri-bilibili-line"></i>
              </a>
              <a
                href="#"
                aria-label="豆瓣"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-800"
              >
                <i className="ri-douban-line"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                {col.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <a
                      href={link.to}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-background-200 pt-6">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 洞洞杂货铺世界观解析站 · 所有解析内容均为读者整理，仅供交流学习
          </p>
          <p className="text-xs text-foreground-600">
            联系邮箱：hello@dongdong.example.com
          </p>
        </div>
      </div>
    </footer>
  );
}